export { default, type CtaSectionProps } from './CtaSection';
